<template>
  <div>
    <header>
      <visitor/>
    </header>
    <main class="ui_index">
      <index :freePlayBuutton="true"/>
    </main>

  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Visitor from '../../visitor/Visitor';
import Index from '../../visitor/Index';

export default {
  name: 'getStartedFreePlay',
  components: {
    Visitor,
    Index,
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from , next) {
    next((vm) => {
      vm.getParameterInfo(to);
    });
  },
  methods: {
    ...mapMutations('i18n', [
      'updateLocaleFromLocalStorage',
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    getParameterInfo(to) {
      console.log(to.query.lang);
     // console.log(to.query.refUrl);
    },
    playTrial() {
      console.log('playing...');
      this.$router.replace('trial/gameFreePlay');
    },
    changeLanguage(newValue) {
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile();
      this.changeCSSFile();
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GetStartedFreePlay.vue